<template>
  <div id="app">
    <div class="row">
      <div class="col-12">
        <h2 ref="clientsTitle" class="generalTitle">Clientes</h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="debouncedFilter" />
      </div>

      <!-- Barra de progreso, solo para la carga inicial -->
      <div v-if="loading && !loadingPagination" class="col-12 mb-3">
        <div class="progress-bar-container">
          <div class="progress-bar"></div>
        </div>
      </div>


      <!-- Clientes list -->
      <div class="col-12" v-if="!loading && clients && clients.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1 flex-wrap">
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }} clientes</p>
              <a href="#" data-toggle="modal" data-target="#uploadWhitelist" class="mb-3 text-right">
                <v-icon name="bi-upload" scale="1.1" /> CARGA CLIENTES WHITELIST
              </a>
            </div>
            <list :clients="clients" @selectOrder="selectOrder($event)" />
            <!-- Spinner de precarga al cambiar número de clientes -->
            <div v-if="loadingPagination" class="text-center mt-3 mb-3">
              <div class="spinner-border" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>
            <div class="row">

              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">

                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                            @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Clientes por página</label>
                </div>
              </div>

              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage="currentPage" :numberPages="numberPages" @selectPage="selectPage" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center" v-if="!loading && (!clients || clients.length === 0)">
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>

    </div>
    <ExportData :id="'exportData'" :modalTitle="'EXPORTAR DATOS'" :class="'modal-xl'" :showFooter="false"
                :filters="filters" :order="order"></ExportData>
    <UploadWhitelist :id="'uploadWhitelist'" :modalTitle="'CARGAR DATOS WHITELIST'" :class="'modal-lg'" :showFooter="false"
                     :filters="filters" :order="order"></UploadWhitelist>

    <ClientDetail :id="'clientDetail'" :modalTitle="'INFORMACIÓN DEL CLIENTE'" :class="'modal-xl'" :clientInfo="clientInfo" @refreshParentList="loadClients"></ClientDetail>
  </div>
</template>

<script>
import axios from 'axios';
import { debounce } from 'lodash';
import List from './templates/List.vue';
import ListFilters from '@/components/Widgets/Shared/ClientListFilters.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
import ExportData from './templates/ExportData.vue';
import UploadWhitelist from './templates/UploadWhitelist.vue';
import ClientDetail from './templates/ClientEdit.vue';

export default {
  name: 'App',
  data() {
    return {
      loading: true,
      loadingPagination: false,
      name: '',
      surnames: '',
      documentNumber: '',
      email: '',
      phone: '',
      fromDate: '',
      toDate: '',
      whiteList: '',
      clients: [],
      filters: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
      clientInfo: '',
    };
  },
  components: {
    List,
    ListFilters,
    Pagination,
    ExportData,
    UploadWhitelist,
    ClientDetail,
  },
  created() {
    this.loadClients();
    this.debouncedFilter = debounce(this.filter, 300); // Implementación de debounce
  },
  methods: {
    filter(value) {
      this.name = value.name !== undefined ? value.name : this.name;
      this.surnames = value.surnames !== undefined ? value.surnames : this.surnames;
      this.documentNumber = value.documentNumber !== undefined ? value.documentNumber : this.documentNumber;
      this.documentNumberCompany = value.documentNumberCompany !== undefined ? value.documentNumberCompany : this.documentNumberCompany;
      this.phone = value.phone !== undefined ? value.phone : this.phone;
      this.email = value.email !== undefined ? value.email : this.email;
      this.fromDate = value.from !== undefined ? value.from : this.fromDate;
      this.toDate = value.to !== undefined ? value.to : this.toDate;
      this.whiteList = value.whiteList !== undefined ? value.whiteList : this.whiteList;
      this.currentPage = 0;
      this.loadClients();
    },
    filterName() {
      if (this.name !== '' && this.name !== undefined) {
        this.filters = `${this.filters}name=${this.name}&`;
      }
    },
    filterSurnames() {
      if (this.surnames !== '' && this.surnames !== undefined) {
        this.filters = `${this.filters}surnames=${this.surnames}&`;
      }
    },
    filterDocumentNumber() {
      if (this.documentNumber !== '' && this.documentNumber !== undefined) {
        this.filters = `${this.filters}legalIdentifier=${this.documentNumber}&`;
      }
    },
    filterDocumentNumberCompany() {
      if (this.documentNumberCompany !== '' && this.documentNumberCompany !== undefined) {
        this.filters = `${this.filters}legalIdentifier=${this.documentNumberCompany}&`;
      }
    },
    filterPhone() {
      if (this.phone !== '' && this.phone !== undefined) {
        this.filters = `${this.filters}mobile=${this.phone}&`;
      }
    },
    filterEmail() {
      if (this.email !== '' && this.email !== undefined) {
        this.filters = `${this.filters}email=${this.email}&`;
      }
    },
    filterFrom() {
      if (this.fromDate !== '' && this.fromDate !== undefined) {
        this.filters = `${this.filters}dateFrom=${this.$dateFrontToBack(this.fromDate)}&`;
      }
    },
    filterTo() {
      if (this.toDate !== '' && this.toDate !== undefined) {
        this.filters = `${this.filters}dateTo=${this.$dateFrontToBack(this.toDate)}&`;
      }
    },
    filterWhiteList() {
      if (this.whiteList !== '' && this.whiteList !== undefined) {
        this.filters = `${this.filters}trustworthy=${this.whiteList}&`;
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}pagination.page=${parseInt(this.currentPage + 1)}&`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.scrollToTop(); // Subir al top cuando se cambia la página
      this.loadClients();
    },
    scrollToTop() {
      const element = this.$refs.clientsTitle;
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    selectOrder(value) {
      console.log(value);
    },
    changeItemsPerPage() {
      this.loadingPagination = true; // Spinner para cambio de número de clientes
      this.currentPage = 0;
      this.loadClients();
    },
    loadClients() {
      this.filters = '';
      this.filterName();
      this.filterSurnames();
      this.filterDocumentNumber();
      this.filterDocumentNumberCompany();
      this.filterPhone();
      this.filterEmail();
      this.filterFrom();
      this.filterTo();
      this.filterWhiteList();
      this.filterPagination();

      if (!this.loadingPagination) {
        this.loading = true; // Barra de carga progresiva solo cuando no es cambio de número de clientes
      }

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      const vm = this;
      let apiUrl = '';
      if (!this.$store.state.roles.Backoffice_member_empresas) {
        apiUrl = '/customer/search';
      } else {
        apiUrl = '/business/customer/search';
      }
      axios.get(apiUrl + `${this.filters}`)
          .then((response) => {
            this.loading = false;
            this.loadingPagination = false; // Ocultamos el spinner
            vm.clients = response.data.customers;
            vm.totalItems = response.data.pagination.totalElements;
            vm.filters = '';
            vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
                ? vm.totalItems / vm.itemsPerPage
                : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

            vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
            vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
                ? vm.totalItems
                : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;
          })
          .catch(() => {
            this.loading = false;
            this.loadingPagination = false; // Aseguramos que el spinner se oculte si hay un error
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropzone-container {
  max-height: unset;
}

.progress-bar-container {
  width: 100%;
  height: 4px;
  background-color: #f3f3f3;
  position: relative;
  margin-bottom: 10px;
}

.progress-bar {
  width: 0;
  height: 100%;
  background-color: #97055D;
  animation: loading 2s infinite;
}

@keyframes loading {
  0% {
    width: 0;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}

.spinner-border {
  width: 2rem;
  height: 2rem;
  border-width: 0.25rem;
  color: #97055D;
}
</style>
